import { isRPSOCRTraditionalAccount } from '../../flows/front-office/shared/utils';

export const ocrConsentAgreementText = accountType => {
  const isOCRTraditionalAcc = isRPSOCRTraditionalAccount(accountType);
  const accountText = isOCRTraditionalAcc ? 'Traditional' : 'Roth';
  return [
    `Based upon our conversation, a Mutual Fund New IRA Account - ${accountText} Rollover IRA form, 
    with all of the information that you have verified for me, will be sent to you for your review. 
    Please review the information in the Mutual Fund New IRA Account - ${accountText} Rollover IRA form carefully 
    and contact us with any changes. You will also be receiving a Signature page. If the information 
    in the Mutual Fund New IRA Account - ${accountText} Rollover IRA form is accurate and complete, please sign the 
    Signature page and return it to T. Rowe Price immediately. Until we receive this signed Signature 
    page, we may place certain restrictions on the account.`,

    `Please note - We may reject, restrict or redeem your account if you fail to 
    give us your correct tax identification number.`,

    `Federal regulations require T. Rowe Price to verify your identity and some of the 
    information that you have provided will be used to perform this verification. We may obtain 
    consumer credit reports (which contain information including credit worthiness, credit standing, 
    and credit capacity) and other information to help verify your identity and to determine whether 
    to establish, maintain or close an account or to restrict certain services.`,

    `The T. Rowe Price Privacy Policy and Traditional and Roth IRA Disclosure Statement 
    and Custodial Agreement will be included in the Mutual Fund Signature packet. Please confirm that it 
    is your intent to open a ${accountText} Rollover IRA today.`
  ];
};
